import Label from "components/Label/Label";
import React from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import CommonLayout from "./CommonLayout";
import { auth } from "../../firebase/config";
import { useForm } from "react-hook-form";
import { useAlert } from "../../@shared/hooks/useAlert";
import { updatePassword } from "firebase/auth";


const AccountPass = () => {
  const userAuth = auth.currentUser;
  const { register, handleSubmit, reset, formState: { errors } } = useForm();
  const alert = useAlert();

  const submit = async (data: any) => {
    if (data.password !== data.repeatPassword) return alert.error("Passwords do not match")
    try {
      await updatePassword(userAuth,  data.password);
      alert.success("Password updated successfully");
      reset();
    } catch (error: any) {
      alert.error(error.message);
    }
  }

  return (
    <div>
      <CommonLayout>
        <div className="space-y-6 sm:space-y-8">
          {/* HEADING */}
          <h2 className="text-3xl font-semibold">Update your password</h2>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          <form onSubmit={handleSubmit(submit)} className=" max-w-xl space-y-6">
            <div>
              <Label>New password</Label>
              <Input type="password" {...register("password",{
                required: "Password is required",
                minLength: {
                  value: 8,
                  message: "Password must be at least 8 characters long",
                },
              })} className="mt-1.5" />
              {errors.password && <p className="text-red-500 text-sm">{errors.password.message as string}</p>}
            </div>
            <div>
              <Label>Confirm password</Label>
              <Input type="password" {...register("repeatPassword")} className="mt-1.5" />
            </div>
            <div className="pt-2">
              <ButtonPrimary>Update password</ButtonPrimary>
            </div>
          </form>
        </div>
      </CommonLayout>
    </div>
  );
};

export default AccountPass;
